export type TranslateFn = (
  key: string,
  options?: { orEmpty?: boolean }
) => string;

const TRANSLATION_KEY_PATTERN = /^[A-Za-z][\w-]*(\.[\w-]+)+$/;

const MAX_TRANSLATION_KEY_LENGTH = 200;

export const isTranslationKeyLike = (value: string): boolean =>
  value.length <= MAX_TRANSLATION_KEY_LENGTH &&
  TRANSLATION_KEY_PATTERN.test(value);

export const translateIfKey = (t: TranslateFn, value: string): string => {
  if (!isTranslationKeyLike(value)) return value;
  return t(value, { orEmpty: true }) || value;
};

/**
 * Translates `key`, returning `fallback` when the key is empty or unknown.
 */
export const getSafeTranslation = (
  t: TranslateFn,
  key: string,
  fallback: string
): string => {
  if (!key) return fallback;
  return t(key, { orEmpty: true }) || fallback;
};
